<template>
    <ul class="navbar-item theme-brand flex-row branding-chrome">
        <li class="nav-item theme-logo">
            <router-link :to="homeTo" class="branding-chrome__logo-link">
                <img
                    :src="logoSrc"
                    class="navbar-logo branding-chrome__logo"
                    :alt="title"
                    @error="onLogoError"
                />
            </router-link>
            <slot name="mobile-extra" />
        </li>
        <li class="nav-item theme-text branding-chrome__text-wrap">
            <router-link :to="homeTo" class="nav-link branding-chrome__title">
                {{ title }}
            </router-link>
            <span
                v-if="showPlatformName && platformName"
                class="branding-chrome__platform"
            >
                {{ platformName }}
            </span>
        </li>
    </ul>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useBrandingStore } from '@/stores/branding';

const props = defineProps({
    homeTo: {
        type: [String, Object],
        default: '/',
    },
    override: {
        type: Object,
        default: null,
    },
});

const branding = useBrandingStore();
const logoFailed = ref(false);
const FALLBACK = '/src/assets/images/logo-mini.png';

const title = computed(() => {
    if (props.override?.display_name) return props.override.display_name;
    return branding.chromeTitle;
});

const logoSrc = computed(() => {
    if (logoFailed.value) return FALLBACK;
    if (props.override?.logo_url) return props.override.logo_url;
    return branding.chromeLogo;
});

/** Mostra o nome da plataforma abaixo da marca do professor (sem “powered by”). */
const showPlatformName = computed(() => {
    if (props.override) {
        return Boolean(props.override.is_customized || props.override.logo_url || props.override.display_name);
    }
    return branding.isCustomized;
});

const platformName = computed(() => {
    if (typeof props.override?.platform_name === 'string' && props.override.platform_name.trim()) {
        return props.override.platform_name.trim();
    }
    return branding.platformName;
});

watch(
    () => [props.override?.logo_url, branding.logoUrl],
    () => {
        logoFailed.value = false;
    }
);

function onLogoError() {
    logoFailed.value = true;
}
</script>

<style scoped>
.branding-chrome {
    justify-content: flex-start !important;
    align-items: center;
    text-align: left;
}
.branding-chrome__text-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    line-height: 1.15;
    text-align: left;
}
.branding-chrome__title {
    color: var(--brand-primary, inherit);
    line-height: 1.2 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    text-align: left;
}
.branding-chrome__platform {
    display: block;
    font-size: 10px;
    font-weight: 500;
    opacity: 0.72;
    margin-top: 0;
    padding-left: 0.8rem;
    white-space: nowrap;
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    line-height: 1.2;
}
.branding-chrome__logo {
    max-height: 36px;
    width: auto;
    object-fit: contain;
    border-radius: 4px;
}
@media (max-width: 991.98px) {
    .branding-chrome__platform {
        max-width: 140px;
        padding-left: 0.5rem;
    }
    .branding-chrome__title {
        padding-left: 0.5rem !important;
    }
}
</style>
